import { createSlice } from "@reduxjs/toolkit";
import cuid from "cuid";

import { MonitoringSliceStateType } from "../types";
import { ClassEventType } from "../types/class_event";
import { MonitoringEventType } from "../types/monitoring_event";

export const initialMonitoringState: MonitoringSliceStateType = {
  class_events: {},
  monitoring_events: {},
};

const monitoringSlice = createSlice({
  name: "monitoring",
  initialState: initialMonitoringState,
  reducers: {
    _createMonitoringEvent(
      state,
      action: { payload: Omit<MonitoringEventType, "id" | "timestamp"> },
    ) {
      const id = cuid();
      state.monitoring_events[id] = {
        id,
        timestamp: Date.now(),
        ...action.payload,
      } as MonitoringEventType;
    },
    _createClassEvent(state, action: { payload: Omit<ClassEventType, "id" | "timestamp"> }) {
      const id = cuid();
      state.class_events[id] = { id, timestamp: Date.now(), ...action.payload } as ClassEventType;
    },
    deleteAllClassEvents(state) {
      state.class_events = {};
    },
  },
});

export const { _createMonitoringEvent, _createClassEvent, deleteAllClassEvents } =
  monitoringSlice.actions;

const monitoringSliceReducer = monitoringSlice.reducer;

export type MonitoringSliceReducerType = typeof monitoringSliceReducer;

export { monitoringSliceReducer };
